import { CompanyEmployees, SimulationAnswer } from '@/modules/simulator/hooks'
import { dispatchEvent } from '@/global/utils'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'

import { sendGTMEvent } from '@next/third-parties/google'
import { Form } from './CompanyDataForm.types'
import {
  getFindOutAliceValue,
  OTHERS,
  SOCIAL_MEDIAS
} from '@/modules/simulator/functions'
import { PEOPLE_6_TO_29 } from '@/modules/simulator/constants/company-size'

const strings = {
  title: 'Agora, vamos precisar de mais algumas informações sobre sua empresa',
  accordionDescription:
    'Precisamos de algumas informações de quem está fazendo a cotação. Ao preenchê-los, você concorda que o nosso time envie o orçamento e informações do plano.',
  submitLabel: 'Concluir cotação'
}

const checkIfFormIsFilled = (formValues: Form) => {
  const {
    companyName,
    responsibleName,
    responsibleEmail,
    telefone,
    findOutAliceSelect,
    otherField,
    socialMediaSelect
  } = formValues

  const isMainFieldsFilled = [
    companyName,
    responsibleName,
    responsibleEmail,
    telefone,
    findOutAliceSelect
  ].every(field => field?.trim())

  const isFindOutAliceFilled =
    (findOutAliceSelect !== OTHERS && findOutAliceSelect !== SOCIAL_MEDIAS) ||
    (findOutAliceSelect === OTHERS && otherField?.trim()) ||
    (findOutAliceSelect === SOCIAL_MEDIAS && socialMediaSelect?.trim())

  return isMainFieldsFilled && isFindOutAliceFilled
}

const buildPayload = (
  data: Form,
  originalAnswers: SimulationAnswer
): SimulationAnswer => {
  const findOutAlice = getFindOutAliceValue({
    findOutAliceSelect: data.findOutAliceSelect,
    socialMediaSelect: data.socialMediaSelect,
    otherField: data.otherField
  })

  return {
    ...originalAnswers,
    responsibleName: data.responsibleName,
    responsiblePhone: data.telefone,
    responsibleEmail: data.responsibleEmail,
    companyName: data.companyName,
    companyCnpj: data.cnpj,
    companyCity: data.city,
    findOutAlice
  }
}

const dispatchAnalyticsEvents = (employeesNumber?: CompanyEmployees) => {
  dispatchEvent({
    eventName: EventName.SIMULATION_SENT,
    buttonName: strings.submitLabel,
    buttonType: ButtonType.NEW_PAGE
  })

  sendGTMEvent({ event: 'pme_b2b_form_sent' })

  if (!employeesNumber) return

  if (employeesNumber === PEOPLE_6_TO_29) {
    sendGTMEvent({ event: 'p_form_sent' })
  } else {
    sendGTMEvent({ event: 'mla_form_sent' })
  }
}

export { strings, buildPayload, dispatchAnalyticsEvents, checkIfFormIsFilled }
